import { Divider, Stack, Typography, useTheme } from "@mui/material";
import { Fragment } from "react/jsx-runtime";
import { ProductIngredient, ProductPackaging } from "src/api/client-api/products/useGetOneProduct";

type ProductEntity = ProductIngredient | ProductPackaging;

type EntitiesDataProps<T extends ProductEntity> = {
    key: string;
    productEntities: T[] | undefined;
    entityDataRowHandler: (productEntity: T) => ReactNode;
    noEntitiesMessage: string;
};

export const EntitiesData = <T extends ProductEntity>(props: EntitiesDataProps<T>) => {
    const { key, productEntities, entityDataRowHandler, noEntitiesMessage } = props;
    const theme = useTheme();

    if (productEntities === undefined || productEntities.length === 0) {
        return (
            <Stack alignItems="center" sx={{ marginBlock: theme.spacing(2) }}>
                <Typography variant="body">{noEntitiesMessage}</Typography>
            </Stack>
        );
    }

    return productEntities?.map((productEntity, index) => {
        const entityDataRow = entityDataRowHandler(productEntity);

        return (
            <Fragment key={`${key}-row-${productEntity.id}`}>
                {entityDataRow}
                {index < (productEntities.length ?? 0) - 1 && <Divider />}
            </Fragment>
        );
    });
};
